import { storyblokEditable } from "@storyblok/react";
import SeasonSummaryCard from "@/components/SeasonSummaryCard";
import { sbBlok } from "@/types/sb-types";

// Storyblok block `season_summary`: one card per entry in `seasons` (each with
// `season_number` and, for finished seasons, the Order of Merit winner), or the
// current season's card when the editor adds none. It can sit on any page.
// /schedule is the exception: ScheduleClient skips this block there and shows
// the card of the season picked in its dropdown instead.
const SeasonSummary = ({ blok }: sbBlok) => {
  const seasons: sbBlok[] = blok?.seasons?.length
    ? blok.seasons
    : [{ _uid: `${blok?._uid}-current` }];

  return (
    <div
      {...storyblokEditable(blok)}
      className="grid-container mb-9 lg:mb-[120px]"
    >
      <div className="col-start-1 col-span-4 lg:col-start-2 lg:col-span-14 2xl:col-start-5 2xl:col-span-24 flex flex-col gap-5">
        {seasons.map((season) => (
          <SeasonSummaryCard key={season._uid} blok={season} />
        ))}
      </div>
    </div>
  );
};

export default SeasonSummary;
